module.exports = __webpack_public_path__ + "static/img/product17-1.4383ee41.png";